// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._bottomNav_cmcjg_1 {
  /* Border */
  --pa-comparison-list-bottom-nav-border-radius-inner: var(--pa-comparison-list-bottom-nav-border-radius, 8px);
  --pa-comparison-list-bottom-nav-border-width-inner: var(--pa-comparison-list-bottom-nav-border-width, 2px);
  --pa-comparison-list-bottom-nav-border-color-inner: var(
    --pa-comparison-list-bottom-nav-border-color,
    var(--perxis-auto-root-second-color-inner)
  );
  /* End Border */
  /* Padding */
  --pa-comparison-list-bottom-nav-padding-inner: var(--pa-comparison-list-bottom-nav-padding, 12px 16px);
  /* End Padding */
  /* Typography */
  --pa-comparison-list-bottom-nav-font-family-inner: var(
    --pa-comparison-list-bottom-nav-font-family,
    var(--perxis-auto-root-typography-super-small-font-family-inner)
  );
  --pa-comparison-list-bottom-nav-font-size-inner: var(
    --pa-comparison-list-bottom-nav-font-size,
    var(--perxis-auto-root-typography-super-small-font-size-xxl-inner)
  );
  --pa-comparison-list-bottom-nav-line-height-inner: var(
    --pa-comparison-list-bottom-nav-line-height,
    var(--perxis-auto-root-typography-super-small-line-height-xxl-inner)
  );
  --pa-comparison-list-bottom-nav-font-weight-inner: var(--pa-comparison-list-bottom-nav-font-weight, 700);
  --pa-comparison-list-bottom-nav-letter-spacing-inner: var(--pa-comparison-list-bottom-nav-letter-spacing, 0.05em);
  --pa-comparison-list-bottom-nav-text-transform-inner: var(
    --pa-comparison-list-bottom-nav-text-transform,
    var(--perxis-auto-root-typography-super-small-text-transform-inner)
  );
  --pa-comparison-list-bottom-nav-color-inner: var(
    --pa-comparison-list-bottom-nav-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Typography */
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: max-content;
  column-gap: 8px;
  padding: var(--pa-comparison-list-bottom-nav-padding-inner);
  border-style: solid;
  border-color: var(--pa-comparison-list-bottom-nav-border-color-inner);
  border-width: var(--pa-comparison-list-bottom-nav-border-width-inner);
  border-radius: var(--pa-comparison-list-bottom-nav-border-radius-inner);
  --perxis-auto-typography-super-small-font-family: var(--pa-comparison-list-bottom-nav-font-family-inner);
  --perxis-auto-typography-super-small-font-weight: var(--pa-comparison-list-bottom-nav-font-weight-inner);
  --perxis-auto-typography-super-small-letter-spacing: var(--pa-comparison-list-bottom-nav-letter-spacing-inner);
  --perxis-auto-typography-super-small-text-transform: var(--pa-comparison-list-bottom-nav-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--pa-comparison-list-bottom-nav-color-inner);
  --perxis-auto-typography-super-small-font-size-xxs: var(--pa-comparison-list-bottom-nav-font-size-inner);
  --perxis-auto-typography-super-small-font-size-xs: var(--pa-comparison-list-bottom-nav-font-size-inner);
  --perxis-auto-typography-super-small-font-size-sm: var(--pa-comparison-list-bottom-nav-font-size-inner);
  --perxis-auto-typography-super-small-font-size-md: var(--pa-comparison-list-bottom-nav-font-size-inner);
  --perxis-auto-typography-super-small-font-size-lg: var(--pa-comparison-list-bottom-nav-font-size-inner);
  --perxis-auto-typography-super-small-font-size-xl: var(--pa-comparison-list-bottom-nav-font-size-inner);
  --perxis-auto-typography-super-small-font-size-xxl: var(--pa-comparison-list-bottom-nav-font-size-inner);
  --perxis-auto-typography-super-small-line-height-xxs: var(--pa-comparison-list-bottom-nav-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xs: var(--pa-comparison-list-bottom-nav-line-height-inner);
  --perxis-auto-typography-super-small-line-height-sm: var(--pa-comparison-list-bottom-nav-line-height-inner);
  --perxis-auto-typography-super-small-line-height-md: var(--pa-comparison-list-bottom-nav-line-height-inner);
  --perxis-auto-typography-super-small-line-height-lg: var(--pa-comparison-list-bottom-nav-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xl: var(--pa-comparison-list-bottom-nav-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xxl: var(--pa-comparison-list-bottom-nav-line-height-inner);
}
@media (min-width: 992px) {
  ._bottomNav_cmcjg_1 {
    display: none;
  }
}
._bottomNav--hidden_cmcjg_72 {
  display: none;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
